import { Map } from 'immutable';
import { selector } from 'lib/selectors';
import { organizationBotSelector } from 'domain/env/envSelector';
import { organization } from 'domain/organization/organizationPureSelector';


const env = (state) => state.env;
const chat = (state) => state.chat;
export const ghostIdentities = ['ghost@dokka.biz', 'ghost@dokka.me', 'ghost@dokka.com'];

// Feature flag selector — true = new UIKit v4 chat, false = legacy v3 chat
// Read directly from organization state to avoid circular dependency
// (organizationSelector.js → companiesSelector.js → chatSelector.js)
export const isNewChatSelector = selector(organization, (org) =>
  org.features?.getIn?.(['enable_chat_v2', 'value']) ?? false,
);

// ========================
// Shared selectors (both versions)
// ========================
export const chatSelector = selector(env, (e) => e.get('chat'));
export const chatParticipantsSelector = selector(chat, (e) => e.get('users'));
export const chatParticipantsByIdSelector = selector(chatParticipantsSelector, (e) =>
  e.reduce((a, v) => a.set(v.userId, v), new Map()),
);

export const activeChannelForceSelector = selector(chat, (c) => c.activeChannelForce);

export const isOpenSelector = selector(chat, (c) => c.isOpen);

export const messagesLoadedSelector = selector(chat, (c) => c.loaded);

export const chatAllUsersSelector = selector(
  chatParticipantsSelector,
  organizationBotSelector,
  (users, organizationBot) => users.unshift(organizationBot),
);

export const chatAllUsersByIdSelector = selector(chatAllUsersSelector, (e) =>
  e.reduce((a, v) => a.set(v.userId, v), new Map()),
);

export const channelUrlSelector = selector(chat, (c) => c.channelUrl);
export const targetTimestampSelector = selector(chat, (c) => c.targetTimestamp);
export const targetMessageIdSelector = selector(chat, (c) => c.targetMessageId);

export const chatUsersCompanyIdSelector = selector(chat, (c) => c.get('usersCompanyId') ?? '');

// Active channel url — used by the toast trigger to suppress toasts for the
// conversation the user is currently viewing.
export const activeChannelSelector = selector(chat, (c) => c.get('activeChannel'));


